/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { BookmarkIcon16Light } from './BookmarkIcon16Light';
import { BookmarkIcon16Regular } from './BookmarkIcon16Regular';
import { BookmarkIcon16Solid } from './BookmarkIcon16Solid';
import { BookmarkIcon20Light } from './BookmarkIcon20Light';
import { BookmarkIcon20Regular } from './BookmarkIcon20Regular';
import { BookmarkIcon20Solid } from './BookmarkIcon20Solid';
import { BookmarkIcon24Regular } from './BookmarkIcon24Regular';
import { BookmarkIcon24Solid } from './BookmarkIcon24Solid';
import { BookmarkIcon32Regular } from './BookmarkIcon32Regular';
import { BookmarkIcon64Regular } from './BookmarkIcon64Regular';
var sizes = {
    16: {
        light: BookmarkIcon16Light,
        regular: BookmarkIcon16Regular,
        solid: BookmarkIcon16Solid,
    },
    20: {
        light: BookmarkIcon20Light,
        regular: BookmarkIcon20Regular,
        solid: BookmarkIcon20Solid,
    },
    24: {
        regular: BookmarkIcon24Regular,
        solid: BookmarkIcon24Solid,
    },
    32: {
        regular: BookmarkIcon32Regular,
    },
    64: {
        regular: BookmarkIcon64Regular,
    },
};
export var BookmarkIcon = forwardRef('BookmarkIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
